import Flickity from 'flickity';
import 'flickity-imagesloaded';

/*
NOTE: not crazy about **any** of this 😂
adjusting the height dynamically w/ JS because I couldn't get flickity to account for
the height of anything other than the image (i.e. text, container height etc.)
(obviously feel free to change this if you have a better solution)
*/

/* padding/height slightly off on firefox, womp womp */
function isFirefox() {
  return typeof InstallTrigger !== 'undefined';
}

function loadRelatedProductsCarousel(carousels) {
  carousels.forEach(carousel => {
    const flk = new Flickity(carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      contain: true,
    });

    flk.on('imagesLoaded', () => {
      matchRelatedProductsHeight(carousel);
    });
  });
}

let cachedTallestSlide = {};

function matchRelatedProductsHeight(carousel) {
  if (!carousel) return;
  const carouselId = carousel.flickityGUID;

  if (cachedTallestSlide[carouselId]) {
    setSlideHeight(carousel, cachedTallestSlide[carouselId]);
    return;
  }

  let cellContent = carousel.querySelectorAll('.carousel-cell > a');
  let tallestSlide = 0;

  cellContent.forEach(slide => {
    const boundingRectHeight = slide.getBoundingClientRect().height;
    const slideHeight = slide.offsetHeight > boundingRectHeight ? slide.offsetHeight : boundingRectHeight;

    if (slideHeight > tallestSlide) {
      tallestSlide = slideHeight;
    }
  });

  if (isFirefox()) {
    tallestSlide += 69;
  } else {
    tallestSlide += 44; /* account for top/bottom padding */
  }

  cachedTallestSlide[carouselId] = tallestSlide;
  setSlideHeight(carousel, tallestSlide);
}

function setSlideHeight(carousel, height) {
  const carouselCells = carousel.querySelectorAll('.carousel-cell');
  carouselCells.forEach(slide => {
    slide.style.height = height + 'px';
  });
}

export function setupRelatedProductsCarousel() {
  const carousels = document.querySelectorAll('.carousel.related-products');

  if (carousels.length) {
    loadRelatedProductsCarousel(carousels);
  }

  const handleResizeAndLoad = () => {
    carousels.forEach(carousel => {
      matchRelatedProductsHeight(carousel);
    });
  };

  document.addEventListener('DOMContentLoaded', handleResizeAndLoad);
  window.addEventListener('resize', handleResizeAndLoad);
}
